//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Radio from '~/components/Shared/Radio.vue'
export default {
  components: {
    Radio,
  },
  props: {
    skill: {
      type: Object,
      required: true,
    },
    tooltipDirection: {
      type: String,
      default: 'is-top',
    },
    showIndicatorPendings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      validationValue: this.hasSkill(this.skill),
    }
  },
  watch: {
    validationValue(newValue, prevValue) {
      this.$emit('change', [this.skill, newValue])
    },
  },
  mounted() {
    this.validationValue = this.hasSkill(this.skill)
  },
  methods: {
    hasSkill(skill) {
      if (skill.supervisor_validate_skill == null) {
        return null
      }
      return skill.supervisor_validate_skill
    },
  },
}
